import {
  getAPIUrl,
  downloadCSV,
} from '../helpers/App';

export const APIgetExports = params => (
  window.axios.get(getAPIUrl('/exports'), { params })
    .then(response => (response.data))
);

export const APIcreateExport = params => (
  window.axios.post(getAPIUrl('/exports'), params)
    .then(response => (response.data))
);

export const APIgetExport = uuid => (
  window.axios.get(getAPIUrl(`/exports/${uuid}`))
    .then(response => (response.data))
);

export const APIdeleteExport = uuid => (
  window.axios.delete(getAPIUrl(`/exports/${uuid}`))
    .then(response => (response.data))
);

export const APIdownloadExport = (path, fileName) => (
  fetch(path)
    .then((response) => response.text())
    .then((data) => downloadCSV(data, fileName))
);
